import { Button, Grid, Typography } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";
import { ImageData } from "../../redux/inspection/state";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/store";
import styles from "./RepairPhot.module.css";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import { ButtonTextGrid } from "../..";
import moment from "moment";

interface Props {
  handleMouseUp: (index: number) => void;
  rotation: number[];
  handleImageClick: (index: number) => void;
  handleDeleteImage: (inspection: ImageData) => void;
  handleChangeCleaningPhoto: (
    event: ChangeEvent<HTMLInputElement>,
    sub_question: ImageData,
    isFurtherAction?: boolean,
  ) => void;
  handleClickReview:(reviewDate:number)=>void;
}

function RepairPhoto(props: Props) {
    const { user } = useSelector((state: IRootState) => state.userAuth);
  const { selectedInspectionItem ,selected_inspection} = useSelector(
    (state: IRootState) => state.inspectionState,
  );
  const [repairImages, setRepairImages] = useState<ImageData[]>([]);
  const [needRepairImage, setNeedRepairImage] = useState<ImageData[]>([]);

  useEffect(() => {
    const repairImages = (
      selectedInspectionItem?.imageArray as ImageData[]
    ).filter((img) => (img.is_further_action || 0) === 1);

    const needRepairImage = (
      selectedInspectionItem?.imageArray as ImageData[]
    ).filter((img) => (img.is_further_action || 0) === 0);

    setRepairImages(repairImages);
    setNeedRepairImage(needRepairImage);
  }, []);

  function generateRepiarBtn(inrepair: ImageData) {
    if (inrepair.answer_id === 0) {
      return <></>;
    } else {
      return (
        <Grid key={`waitRepair-${inrepair.inspection_response_id}`}>
          <input
            accept="image/*"
            id={`waitRepair-${inrepair.inspection_response_id}`}
            type="file"
            style={{ display: "none" }}
            onChange={(e) => props.handleChangeCleaningPhoto(e, inrepair, true)}
          />
          <label htmlFor={`waitRepair-${inrepair.inspection_response_id}`}>
            <Button
              variant="contained"
              component="span"
              style={{ backgroundColor: "#d32f2f" }}
            >
              {`添加 ${inrepair.parent_question} - ${inrepair.sub_question} 相片`}
            </Button>
          </label>
        </Grid>
      );
    }
  }

  return (
    <Grid style={{ width: "100%" }}>
      <Grid style={{ display: "flex", justifyContent: "flex-start", gap:40 ,marginBottom:30}}>
        {needRepairImage.length > 0 &&
          needRepairImage.map((inrepair) => generateRepiarBtn(inrepair))}
      </Grid>

      <Grid style={{display:'flex',justifyContent:'flex-start',alignItems:'center',flexWrap:'wrap',gap:40}}>
        {repairImages.length > 0 ? (
          repairImages.map((repair) => (
            <Grid
              key={`group-${repair.inspection_response_id}`}
              style={{
                display: repair.answer_id == 0 ? "none" : "flex",
                flexDirection: "column",
                gap: 30,
                marginBottom: 40,
                alignSelf: "flex-start",
              }}
            >
              <Grid
                style={{
                  fontSize: 24,
                  marginTop: 0,
                  marginBottom: 0,
                  fontWeight: "bold",
                  minHeight: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {`修復後｜${repair.parent_question}-${repair.sub_question}`}
              </Grid>

              <div className={styles.imageRowContainer}>
                <div
                  key={`image-${repair.inspection_response_id}-${repair.inspection_image_id}`}
                  className={styles.imageItemContainer}
                >
                  <div
                    onClick={() =>
                      props.handleMouseUp(repair.inspection_response_id)
                    }
                  >
                    <img
                      src={`${process.env.REACT_APP_S3}${repair.image_thumb}`}
                      alt=""
                      style={{
                        margin: 0,
                        padding: 0,
                        display: "block",
                        maxHeight: "300px",
                        width: "auto",
                        height: "auto",
                        transform: `rotate(${props.rotation[repair.inspection_response_id] || 0}deg)`,
                      }}
                    />
                  </div>
                </div>

                <div
                  className={styles.ButtonContainer}
                  onClick={() =>
                    props.handleImageClick(repair.inspection_response_id)
                  }
                >
                  <Button variant="contained">
                    <ButtonTextGrid>
                      <RotateRightIcon />
                      <Grid>右轉45度</Grid>
                    </ButtonTextGrid>
                  </Button>
                </div>

                <div
                  className={styles.ButtonContainer}
                  onClick={() => props.handleDeleteImage(repair)}
                >
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "red" }}
                  >
                    <RotateRightIcon />
                    <Grid>刪除圖片</Grid>
                  </Button>
                </div>
              </div>

           
            </Grid>
          ))
        ) : (
          <Grid style={{ width: "100%" }}>
            <Grid style={{ padding: 20, textAlign: "center" }}>
              <Typography>沒有檢查時的照片</Typography>
            </Grid>
          </Grid>
        )}

           <Grid
                style={{
                  borderTopStyle: "solid",
                  borderWidth: 2,
                  borderColor: "black",
                  width: "100%",
                }}
              >
                {selected_inspection?.is_approved &&
                selected_inspection?.is_approved == 1 ? (
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: 30,
                      gap: 30,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Grid>
                      審核者 ： {selected_inspection.reviewer}
                    </Grid>

                    <Grid>
                      審核日期 ：{" "}
                      {moment(
                        parseInt(
                          selected_inspection.review_date!
                        )
                      )
                        .utcOffset(8)
                        .format("YYYY-MM-DD HH:mm:ss")}
                    </Grid>

                    <Grid>
                      <Button
                        variant="contained"
                        disabled={true}
                      >
                        <ButtonTextGrid>
                          <Grid>確認</Grid>
                        </ButtonTextGrid>
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: 30,
                      gap: 30,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Grid>
                      審核者 ： {user?.token?.username}
                    </Grid>

                    <Grid>
                      現在審批日期 ：{" "}
                      {moment()
                        .utcOffset(8)
                        .format("YYYY-MM-DD HH:mm:ss")}
                    </Grid>

                    <Grid>
                      <Button
                        variant="contained"
                        onClick={() =>
                          props.handleClickReview(
                            moment().local().valueOf()
                          )
                        }
                        disabled={false}
                      >
                        <ButtonTextGrid>
                          <Grid>審批</Grid>
                        </ButtonTextGrid>
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>
      </Grid>
    </Grid>
  );
}

export default RepairPhoto;
